import { AccountApiError, isRecord, requestAccountJson } from "./account-api";

export async function requestMagicLink(input: {
  email: string;
  redirectUrl: string;
}): Promise<{ ok: true; message: string }> {
  const payload = await requestAccountJson({
    endpoint: "/api/auth/request-link",
    init: {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        email: input.email,
        redirectUrl: input.redirectUrl
      })
    },
    unavailableCode: "auth_request_unavailable",
    httpCode: "auth_request_http",
    invalidCode: "auth_request_invalid"
  });

  if (!isRecord(payload) || payload.ok !== true || typeof payload.message !== "string") {
    throw new AccountApiError("auth_request_invalid", "Invalid sign-in response", {
      endpoint: "/api/auth/request-link"
    });
  }
  return { ok: true, message: payload.message };
}

export async function signOut(): Promise<void> {
  await requestAccountJson({
    endpoint: "/api/auth/logout",
    init: { method: "POST" },
    unavailableCode: "auth_logout_unavailable",
    httpCode: "auth_logout_http",
    invalidCode: "auth_logout_invalid"
  });
}
